import { useMemo, useState } from 'react';
import moment from 'moment';
import classNames from 'classnames';
import { useFormatDate } from 'src/utils/hooks/useFormatDate';
import styles from './StageNotes.module.scss';

const INITIAL_DISPLAYED_NOTES = 3;

export interface INote {
  id: number;
  detail: string;
  date: string;
}

const sortNotes = (notes: INote[]) => [...notes].sort((a, b) => moment(b.date).diff(moment(a.date)));

const Note = ({ note, isLast }: { note: INote; isLast: boolean }) => {
  const formattedDate = note.date ? useFormatDate(note.date) : null;
  return (
    <div className={classNames(styles['stage-note-container'], { [styles['note-last-element']]: isLast })}>
      <p className={styles['stage-note-detail']}>{note.detail}</p>
      {formattedDate && <p className={styles['stage-note-added-date']}>{formattedDate}</p>}
    </div>
  );
};

const StageNotes = ({ notes }: { notes: INote[] }) => {
  const sortedNotes = useMemo(() => sortNotes(notes), [notes]);
  const [displayedNotes, setDisplayedNotes] = useState(INITIAL_DISPLAYED_NOTES);
  const viewMore = sortedNotes.length > INITIAL_DISPLAYED_NOTES && displayedNotes !== sortedNotes.length;
  const lastNoteIndex = sortedNotes.length - 1;

  return (
    <div className={styles['stage-notes-container']}>
      <div className={styles['stage-note-helper']}>
        <div className={styles['stage-note-icon']}></div>
        <p className={styles['stage-note-text']}>Notes from Immigration Team</p>
      </div>
      {sortedNotes.slice(0, displayedNotes).map((note, index) => (
        <Note key={note.id} note={note} isLast={displayedNotes <= INITIAL_DISPLAYED_NOTES && index == lastNoteIndex} />
      ))}
      {sortedNotes.length > INITIAL_DISPLAYED_NOTES && (
        <div
          className={styles['notes-view-more-updates']}
          onClick={() => setDisplayedNotes(viewMore ? sortedNotes.length : INITIAL_DISPLAYED_NOTES)}
        >
          <div className={viewMore ? `${styles['view-more-notes-icon']}` : `${styles['view-less-notes-icon']}`}></div>
          <p>
            View {viewMore ? `more` : `less`} updates
            {viewMore && ` (${sortedNotes.length - INITIAL_DISPLAYED_NOTES})`}
          </p>
        </div>
      )}
    </div>
  );
};

export default StageNotes;
